<template>
  <div>
    <h1>正在退出登录...</h1>
  </div>
</template>

<script>
export default {
  mounted() {
    // 清除 cookies 中的用户信息
    this.$cookies.remove('username')
    this.$cookies.remove('ticket')
    // 显示退出成功的消息
    this.$toast('退出成功', 'succ')
    // 跳转到登录页面
    this.$router.push('/login')
  }
}
</script>
